<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :actions="actions"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      ref="grid"
      :selectionEnabled="false"
    ></dx-grid>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.title,
    };
  },
  data: () => ({
    url: "",
    title: "ManageEngine Categories",
    actions: [],
    columns: [
      {
        label: "Id",
        field: "id",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },


      {
        label: "Deleted",
        field: "deleted",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  created() {
    this.actions.push({
      text: "Sync Categories",
      action: this.syncCategories,
    });
    this.actions.push({
      text: "Edit Categorys on ManageEngine",
      action: this.openManageEngineCategories,
    });
  },
  methods: {
    async syncCategories() {
      try {
        await this.$http.post(
          "api/ManageengineCategories/SyncManageEngineCategories"
        );
      } catch (error) {
        this.$notify({
          group: "notification",
          text: "Error syncing categories",
          type: "error",
        });
        return;
      }
      this.$refs.grid.reloadGrid();
      this.$notify({
        group: "notification",
        text: "Categories synced successfully",
        type: "success",
      });
    },
    async beforeSetupGrid() {
      this.url = "ManageengineCategories";
    },
    async openManageEngineCategories() {
      window.open("https://utaw.sdpondemand.manageengine.com/app/itdesk/AdminDetails.cc?forwardTo=category", "_blank");
    },
  },
};
</script>
